/**
 * La pluie de caractères, côté calcul.
 *
 * Chaque colonne est décrite une fois au montage, puis animée **entièrement en
 * CSS** : aucune image n'est calculée en JavaScript, c'est la seule façon de la
 * garder fluide sur un téléphone pendant que le mixeur travaille.
 */

/**
 * Katakana demi-chasse et chiffres, comme dans le film — et comme dans le
 * handoff. Ces glyphes ne sont pas dans IBM Plex Mono : la pile de polices de
 * la pluie prévoit un repli japonais, et les chiffres restent lisibles partout
 * même si un système n'a aucune police japonaise.
 */
const GLYPHS = [...'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓ0123456789'];

/** Nombre de colonnes en large ; le CSS en masque une partie en étroit. */
export const RAIN_COLUMNS = 18;

export interface RainColumn {
  /** Position horizontale, en pourcentage de la largeur. */
  readonly left: number;
  /** Durée de la chute, en secondes. */
  readonly duration: number;
  /** Retard au démarrage, pour que les colonnes ne tombent pas ensemble. */
  readonly delay: number;
  readonly glyphs: string;
}

/**
 * Répartit les colonnes régulièrement, avec juste assez de désordre pour que
 * l'œil n'y lise pas une grille. Le tirage est injectable : les tests savent
 * alors exactement ce qui sort.
 */
export function makeRain(count = RAIN_COLUMNS, random = Math.random): RainColumn[] {
  const step = 100 / count;
  return Array.from({ length: count }, (_, index) => {
    const jitter = (random() - 0.5) * step * 0.7;
    const length = 14 + Math.floor(random() * 13);
    return {
      left: Math.min(97, Math.max(0.4, index * step + jitter)),
      duration: 7 + random() * 9,
      delay: random() * 10,
      glyphs: Array.from(
        { length },
        () => GLYPHS[Math.floor(random() * GLYPHS.length)] ?? '0',
      ).join(''),
    };
  });
}
